<!-- quote-preview.component.html -->
<!-- 📱 MOBILE — version actuelle, conservée telle quelle -->
<div class="md:hidden">
  <!-- 🔮 Quote Preview Premium -->
  <div class="rounded-2xl border border-purple-400/40 p-4 bg-white ">
    <!-- Titre -->
    <div class="flex items-center gap-2 mb-4">
      <div class="w-6 h-6 bg-gradient-to-tr from-purple-500 to-indigo-500 text-white rounded-full flex items-center justify-center shadow-md">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>

      <h1 class="text-base font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-600 dark:from-indigo-400 dark:to-purple-300">
        {{ 'QUOTE_PREVIEW' | translate }}
      </h1>
    </div>




    <div class="space-y-4 text-sm text-gray-800 dark:text-gray-200">
      <!-- Détail du Swap -->
      <div class="flex justify-between items-center">
        <div>{{ 'NETWORK' | translate }}</div>
        <div class="text-right font-semibold text-black dark:text-white">
          <div class="flex items-center gap-2 justify-end">

            <span>{{ getNetworkName(quote?.fromChainId) }}</span>
          </div>
        </div>
      </div>
      <!-- Source DEX -->
      <div class="flex justify-between items-center">
        <div>{{ 'DEX_SOURCE' | translate }}</div>
        <div class="flex items-center gap-2 text-right">
          <img *ngIf="swapIconUrl" [src]="swapIconUrl" alt="DEX" class="w-5 h-5 rounded-full" />
          <div class="font-semibold text-black dark:text-white">
            {{ dexSource }}
          </div>

        </div>
      </div>
      <!-- Token à vendre -->
      <div class="flex justify-between items-center">
        <div>{{ 'SELL_TOKEN' | translate }}</div>
        <div class="text-right">
          <div class="font-semibold text-black dark:text-white">
            {{ formatAmount(displayedSellAmount, 6) }} {{ getTokenLabel(sellTokenSymbol) }}
          </div>
          <div *ngIf="getSellAmountFiat()" class="text-xs text-black">≈ {{ getSellAmountFiat() }}</div>
        </div>
      </div>

      <!-- Token estimé -->
      <div class="flex justify-between items-center">
        <div>{{ 'BUY_TOKEN_ESTIMATED' | translate }}</div>
        <div class="text-right">
          <div class="font-semibold text-black dark:text-white">
            {{ formatAmount(displayedBuyAmount, 6) }} {{ getTokenLabel(buyTokenSymbol) }}
          </div>
          <div *ngIf="getBuyAmountFiat()" class="text-xs text-black">≈ {{ getBuyAmountFiat() }}</div>
        </div>
      </div>

      <!-- Prix du gas (en Gwei)
    <div class="flex justify-between items-center">
      <div>{{ 'GAS_PRICE' | translate }}</div>
      <div class="text-right font-semibold text-black dark:text-white">
        <div>{{ displayedGasPriceGwei }} Gwei</div>
      </div>
    </div>-->
      <!-- Frais réseau -->
    <div class="mt-8">
      <!-- Ligne principale -->
      <div class="flex justify-between items-center">
        <div>{{ 'NETWORK_FEE' | translate }}</div>
        <div class="font-semibold text-black dark:text-white">
          {{ lifiFeeRow.textEth || '—' }}
        </div>
      </div>
      <!-- Détails + Badge (colonne droite seulement) -->
      <div class="text-right">
        <div *ngIf="getGasFeeFiat()" class="text-xs text-black dark:text-white opacity-80">
          {{ lifiFeeRow.textFiat }}
        </div>

        <!-- ✅ Badge sous le fiat -->
        <!--<div *ngIf="networkFeeGainAbs > 0.01"
            class="mt-1 flex justify-center items-center relative cursor-pointer"
            (click)="toggleTooltip()">
         <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full
    bg-purple-50/80 text-purple-700 border border-purple-200
    dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/30
    text-[11px] font-semibold">
           <svg class="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
             <path fill-rule="evenodd"
                   d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 9.85a1 1 0 011.414-1.414l3.122 3.122 6.364-6.364a1 1 0 011.414 0z"
                   clip-rule="evenodd" />
           </svg>
           {{ 'You saved' | translate }}
           {{ networkFeeGainAbs | number:'1.2-2' }} {{ fiatCode }}
           ({{ networkFeeGainPct | number:'1.0-1' }}%)
           <span class="ml-1 w-3 h-3 flex items-center justify-center rounded-full
       bg-white dark:bg-white text-purple-700
       text-[10px] font-bold">i</span>
         </span>-->
        <!-- Tooltip contrôlé uniquement par Angular -->
        <!--<div *ngIf="showTooltip"
           class="absolute bottom-full right-0 mb-1
        bg-gray-800 text-white text-[11px] rounded-md px-2 py-1
        shadow-lg whitespace-nowrap z-50">
        {{ 'Compared to the most expensive route' | translate }}
      </div>
    </div>-->

      </div>
    </div>

      <!-- Alerte perte -->
      <div *ngIf="isCriticalLoss"
           class="text-xs font-semibold text-center text-red-600 dark:text-red-400 bg-red-100/40 dark:bg-red-400/10 border border-red-300/30 px-3 py-1 rounded-xl mt-2 animate-pulse">
        🚨 {{ 'NET_LOSS' | translate }} {{ formatAmount(netLossFiat, 2) }} {{ fiatCode }}
      </div>


    </div>

    <!-- Statut -->
    <div class="text-sm text-center my-6 font-medium space-y-2">
      <div *ngIf="swapStatus === 'approve'" class="text-blue-600 dark:text-blue-300">🔐 {{ 'APPROVE_PENDING' | translate }}</div>
      <div *ngIf="swapStatus === 'pending'" class="text-blue-600 dark:text-blue-300">⏳ {{ 'SWAP_PENDING' | translate }}</div>
      <div *ngIf="swapStatus === 'success'" class="text-green-600 dark:text-green-400">
        ✅ {{ 'SWAP_SUCCESS' | translate }}
        <a [href]="'https://etherscan.io/tx/' + swapHash" target="_blank" class="underline ml-1">
          {{ swapHash | slice:0:10 }}...
        </a>
      </div>
      <div *ngIf="swapStatus === 'cancelled' || (swapStatus === 'error' && isUserCancelled(swapError))"
           class="text-gray-600 dark:text-gray-300 flex items-center justify-center gap-2">
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-4.75h1.5v1.5h-1.5v-1.5zm0-7h1.5v5h-1.5v-5z" /></svg>
        <span>{{ 'SWAP_CANCELLED' | translate }}</span>
      </div>
      <div *ngIf="swapStatus === 'error' && !isUserCancelled(swapError)" class="text-gray-600 dark:text-gray-300">
        ℹ️ {{ 'SWAP_INFO' | translate }} : {{ getFormattedSwapError(swapError) }}
      </div>
    </div>

    <!-- Actions -->
    <div class="flex justify-between items-center text-xs gap-3">
      <div class="flex-1 flex flex-col items-center cursor-pointer hover:bg-gray-100/40 dark:hover:bg-white/5 p-1.5 rounded-lg transition glow-btn" (click)="onShareClick()">
        <img src="assets/icons/share-envelope.png" alt="Share" class="w-auto h-4" />
        <span class="text-[#144C72] font-semibold text-xs tracking-wide">{{ 'SHARE' | translate }}</span>
      </div>

      <div *ngIf="quote" class="flex-1 flex flex-col items-center p-1.5 rounded-lg validate-btn"
           [ngClass]="{ 'opacity-40 cursor-not-allowed pointer-events-none': swapDisabled }"
           (click)="!swapDisabled && executeRequest.emit()">
        <img src="assets/icons/validate-checkmark.png" alt="Valider" class="w-6 h-auto object-contain -mt-0.5" [ngClass]="swapDisabled ? 'grayscale' : ''" />
        <span class="font-semibold tracking-wide text-xs" [ngClass]="swapDisabled ? 'text-gray-400 dark:text-gray-500' : 'text-green-700 dark:text-green-300'">
          {{ 'VALIDATE' | translate }}
        </span>
      </div>
    </div>


    <div class="my-3 text-center"
         *ngIf="(quote?.singleRoutes?.length || 0) > 1 && !showAlternatives">
      <button type="button"
              class="inline text-sm font-medium text-blue-600 underline
 p-0 m-0 bg-transparent !border-0 !shadow-none !ring-0
 hover:!shadow-none hover:bg-transparent
 focus:!outline-none focus:!ring-0 active:!shadow-none
 appearance-none rounded-none select-none"
              (click)="showAlternatives = true">
        {{ 'SEE_OTHER_RESULTS' | translate }}
      </button>
    </div>

    <!-- Tableau des alternatives -->
    <div *ngIf="showAlternatives" class="my-4">
      <div class="overflow-hidden rounded-2xl border bg-white/90 dark:bg-[#0f1220]/80
        border-purple-200/60 dark:border-white/10
        text-slate-800 dark:text-slate-200">

        <div class="px-3">
          <div class="-mx-4 -mt-4 px-4 pt-4 rounded-t-2xl bg-purple-50/80 dark:bg-white/5">
            <table class="w-full table-fixed text-[12px] leading-tight">
              <thead>
                <tr class="text-left">
                  <th class="py-2 font-semibold pr-3">{{ 'ESTIMATED_RECEIVED_TOKEN' | translate }}</th>
                  <th class="py-2 font-semibold pr-3">{{ 'NETWORK_FEE' | translate }}</th>
                  <th class="py-2 text-right font-semibold">{{ 'ACTION' | translate }}</th>
                </tr>
              </thead>
            </table>
          </div>
          <table class="w-full table-fixed text-[12px] leading-tight">
            <tbody>
              <ng-container *ngFor="let r of otherRoutes">
                <!-- Ligne 1 : Provider -->
                <tr class="border-t border-gray-100/70 dark:border-white/10">
                  <td colspan="3" class="pt-2 pb-1">
                    <div class="flex items-center gap-2">
                      <img *ngIf="getRouteLogo(r)" [src]="getRouteLogo(r)!" alt=""
                           class="w-5 h-5 rounded-full shrink-0" />
                      <span class="font-medium truncate">{{ getRouteProvider(r) }}</span>
                    </div>
                  </td>
                </tr>

                <!-- Ligne 2 : Reçu | Frais | Action -->
                <tr class="border-b border-gray-100/70 dark:border-white/10">
                  <!-- Reçu -->
                  <td class="pl-1 pr-1 pb-2 align-top w-[46%]">
                    <div class="text-[11px] text-slate-500 dark:text-slate-400">
                      {{ getRouteEstimatedBuy(r) }}
                    </div>
                    <div class="text-[11px] text-slate-500 dark:text-slate-400"
                         *ngIf="getRouteEstimatedBuyFiat(r) as fiat">
                      {{ fiat }}
                    </div>
                  </td>

                  <!-- Frais réseau -->
                  <td class="pl-5 pr-1 pb-2 align-top w-[34%] whitespace-nowrap">
                    <ng-container *ngIf="getRouteLifiFee(r) as lifi">
                      <div class="text-[11px] text-slate-500 dark:text-slate-400">{{ lifi.textEth }}</div>
                      <div class="text-[11px] text-slate-500 dark:text-slate-400" *ngIf="lifi.textFiat">
                        {{ lifi.textFiat }}
                      </div>
                    </ng-container>
                  </td>

                  <!-- Action -->
                  <td class="pl-1 pr-2 pb-2 text-right align-top w-[20%]"
                      [attr.data-selected]="isAltSelected(r)">
                    <ng-container *ngIf="!isAltSelected(r); else altSelected">
                      <button type="button"
                              [disabled]="isAlternativeDisabled(r)"
                              (click)="onValidateAlternative(r)"
                              class="px-2 py-1 rounded-xl border text-[11px] leading-none
               text-emerald-700 border-emerald-300
               enabled:hover:shadow-sm enabled:hover:ring-2 enabled:hover:ring-emerald-200
               disabled:bg-transparent disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed
               dark:text-emerald-400 dark:border-emerald-500/30
               dark:enabled:hover:ring-emerald-500/30
               dark:disabled:text-gray-500 dark:disabled:border-gray-600">
                        {{ 'VALIDATE' | translate }}
                      </button>
                    </ng-container>

                    <ng-template #altSelected>
                      <span class="inline-flex items-center gap-1 px-2 py-1 rounded-xl border text-[11px] leading-none
                         bg-emerald-50/80 text-emerald-700 border-emerald-300
                         dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/30">
                        ✓ {{ 'SELECTED' | translate }}
                      </span>
                    </ng-template>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-2 text-center">
        <button type="button"
                class="inline text-sm font-medium text-blue-600 underline
 p-0 m-0 bg-transparent !border-0 !shadow-none !ring-0
 hover:!shadow-none hover:bg-transparent
 focus:!outline-none focus:!ring-0 active:!shadow-none
 appearance-none rounded-none select-none"
                (click)="showAlternatives = false">
          {{ 'CLOSE_TABLE' | translate }}
        </button>
      </div>
    </div>



    <!-- Bouton Fermer -->
    <div class="mt-1 flex justify-end">
      <button class="text-xs font-bold text-black underline flex items-center gap-1" (click)="closePreview()">
        <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </div>
</div>


<!-- 💻 DESKTOP — Premium Compact (fix labels + buttons) -->
<div class="hidden md:block">
  <div class="rounded-3xl border border-purple-300/40 shadow-xl bg-white dark:bg-[#1e1e2f]/90
           p-8 max-w-3xl mx-auto">
    <!-- Header -->
    <div class="flex items-center gap-3 mb-6">
      <div class="w-8 h-8 bg-gradient-to-tr from-purple-500 to-indigo-500 text-white rounded-full flex items-center justify-center shadow-md">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>
      <h1 class="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-600">
        {{ 'QUOTE_PREVIEW' | translate }}
      </h1>
      <span class="text-sm text-black">{{ getNetworkName(quote?.fromChainId) }}</span>
    </div>
    <!-- 🟣 Bloc Main Quote -->
    <div class="bg-white rounded-xl p-6 space-y-4 shadow-none border-0 ring-0">
      <!-- DEX -->
      <div class="flex items-center justify-between">
        <span class="text-sm text-gray-500">{{ 'DEX_SOURCE' | translate }}</span>
        <div class="flex items-center gap-2">
          <img *ngIf="swapIconUrl" [src]="swapIconUrl" alt="DEX" class="w-5 h-5 rounded-full" />
          <span class="font-medium text-gray-900 text-[15px]">{{ dexSource }}</span>
        </div>
      </div>

      <!-- Sell token -->
      <div class="flex items-center justify-between">
        <span class="text-sm text-gray-500">{{ 'SELL_TOKEN' | translate }}</span>
        <span class="font-medium text-gray-900 text-[15px]">
          {{ formatAmount(displayedSellAmount, 6) }} {{ getTokenLabel(sellTokenSymbol) }}
          <span class="text-[13px] opacity-70 align-baseline">
            ≈ {{ getSellAmountFiat() }}
          </span>
        </span>
      </div>

      <!-- Received -->
      <div class="flex items-center justify-between">
        <span class="text-sm text-gray-500">{{ 'BUY_TOKEN_ESTIMATED' | translate }}</span>
        <span class="font-medium text-gray-900 text-[15px]">
          {{ formatAmount(displayedBuyAmount, 6) }} {{ getTokenLabel(buyTokenSymbol) }}
          <span class="text-[13px] opacity-70 align-baseline">
            ≈ {{ getBuyAmountFiat() }}
          </span>
        </span>
      </div>

      <!-- Frais réseau (3 variantes) -->
    
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-500">{{ 'NETWORK_FEE' | translate }}</span>
          <span class="font-medium text-gray-900 text-[14px]">
            {{ lifiFeeRow.textEth || '—' }}
            <span *ngIf="lifiFeeRow.textFiat" class="text-[12px] opacity-70 align-baseline">
              {{ lifiFeeRow.textFiat }}
            </span>
          </span>
        </div>

        <!-- MetaMask (expected) -->
        <!--<div class="flex items-center justify-between">
          <span class="text-xs text-gray-500">MetaMask (expected)</span>
          <span class="font-medium text-gray-900 text-[14px]">
            {{ mmExpectedFeeRow.textEth || '—' }}
            <span *ngIf="mmExpectedFeeRow.textFiat" class="text-[12px] opacity-70 align-baseline">
              {{ mmExpectedFeeRow.textFiat }}
            </span>
          </span>
        </div>-->

        <!-- MetaMask (max) -->
        <!--<div class="flex items-center justify-between">
          <span class="text-xs text-gray-500">MetaMask (max)</span>
          <span class="font-medium text-gray-900 text-[14px]">
            {{ mmMaxFeeRow.textEth || '—' }}
            <span *ngIf="mmMaxFeeRow.textFiat" class="text-[12px] opacity-70 align-baseline">
              {{ mmMaxFeeRow.textFiat }}
            </span>
          </span>
        </div>-->
     


      <!-- Savings badge -->
      <!-- ✅ Badge sous le fiat -->
      <!--<div *ngIf="networkFeeGainAbs > 0.01"
             class="mt-1 flex justify-center items-center relative group cursor-help"
             (click)="toggleTooltip()">
          <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full
               bg-purple-50/80 text-purple-700 border border-purple-200
              dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/30
              text-[11px] font-semibold">
            <svg class="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 9.85a1 1 0 011.414-1.414l3.122 3.122 6.364-6.364a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
            </svg>
            {{ 'You saved' | translate }}
            {{ networkFeeGainAbs | number:'1.2-2' }} {{ fiatCode }}
            ({{ networkFeeGainPct | number:'1.0-1' }}%)
            <span class="ml-1 w-3 h-3 flex items-center justify-center rounded-full
  bg-white dark:bg-white text-purple-700
  text-[10px] font-bold">i</span>
          </span>-->
      <!-- Tooltip -->
      <!--<div class="absolute bottom-full right-0 mb-1 hidden group-hover:block
              bg-gray-800 text-white text-[11px] rounded-md px-2 py-1
              shadow-lg whitespace-nowrap z-50"
         [class.block]="showTooltip">
      {{ 'Compared to the most expensive route' | translate }}
    </div>
  </div>-->

      <br />


      <!-- Statut -->
      <div class="text-sm text-center my-8 font-medium space-y-2">
        <div *ngIf="swapStatus === 'approve'" class="text-blue-600 dark:text-blue-300">🔐 {{ 'APPROVE_PENDING' | translate }}</div>
        <div *ngIf="swapStatus === 'pending'" class="text-blue-600 dark:text-blue-300">⏳ {{ 'SWAP_PENDING' | translate }}</div>
        <div *ngIf="swapStatus === 'success'" class="text-green-600 dark:text-green-400">
          ✅ {{ 'SWAP_SUCCESS' | translate }}
          <a [href]="'https://etherscan.io/tx/' + swapHash" target="_blank" class="underline ml-1">
            {{ swapHash | slice:0:10 }}...
          </a>
        </div>
        <div *ngIf="swapStatus === 'cancelled' || (swapStatus === 'error' && isUserCancelled(swapError))"
             class="text-gray-600 dark:text-gray-300 flex items-center justify-center gap-2">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-4.75h1.5v1.5h-1.5v-1.5zm0-7h1.5v5h-1.5v-5z" /></svg>
          <span>{{ 'SWAP_CANCELLED' | translate }}</span>
        </div>
        <div *ngIf="swapStatus === 'error' && !isUserCancelled(swapError)" class="text-gray-600 dark:text-gray-300">
          ℹ️ {{ 'SWAP_INFO' | translate }} : {{ getFormattedSwapError(swapError) }}
        </div>
      </div>

      <!-- Barre d’actions (compact) -->
      <div class="mt-4 flex justify-between items-stretch gap-3">
        <!-- Share (compact) -->
        <button type="button"
                (click)="onShareClick()"
                class="flex-1 rounded-xl px-3 py-2 border hover:shadow-sm transition
                 bg-white text-blue-700 border-blue-200 text-sm
                 dark:bg-transparent dark:text-blue-300 dark:border-blue-500/30">
          <div class="flex items-center justify-center gap-2 font-semibold">
            <img src="assets/icons/share-envelope.png" class="h-4 w-auto" alt="Share" />
            <span>{{ 'SHARE' | translate }}</span>
          </div>
        </button>

        <!-- Validate (compact) -->
        <button type="button"
                [disabled]="swapDisabled || !quote"
                (click)="!swapDisabled && quote && executeRequest.emit()"
                class="flex-1 rounded-xl px-3 py-2 border transition
                 bg-white border-green-200 text-green-700 text-sm
                 enabled:hover:shadow-sm enabled:hover:ring-2 enabled:hover:ring-green-300
                 disabled:opacity-40 disabled:cursor-not-allowed
                 dark:bg-transparent dark:text-green-300 dark:border-green-500/30">
          <div class="flex items-center justify-center gap-2 font-semibold">
            <img src="assets/icons/validate-checkmark.png" class="h-4 w-auto" alt="Validate" />
            <span>{{ 'VALIDATE' | translate }}</span>
          </div>
        </button>
      </div>



      <!-- Autres résultats : lien d’ouverture -->
      <div class="my-3 text-center"
           *ngIf="(quote?.singleRoutes?.length || 0) > 1 && !showAlternatives">
        <button type="button"
                (click)="showAlternatives = true"
                class="inline text-sm font-medium text-blue-600 underline
                 p-0 m-0 bg-transparent !border-0 !shadow-none !ring-0
                 hover:!shadow-none hover:bg-transparent
                 focus:!outline-none focus:!ring-0 active:!shadow-none
                 appearance-none rounded-none select-none">
          {{ 'SEE_OTHER_RESULTS' | translate }}
        </button>
      </div>

      <!-- Tableau des alternatives -->
      <div *ngIf="showAlternatives" class="my-4">
        <div class="overflow-hidden rounded-2xl border bg-white/90 dark:bg-[#0f1220]/80
       border-purple-200/60 dark:border-white/10
       text-slate-800 dark:text-slate-200">
          <table class="w-full text-sm">
            <thead class="bg-purple-50/80 dark:bg-white/5">
              <tr class="text-left">
                <th class="px-4 py-2 font-semibold">{{ 'PROVIDER' | translate }}</th>
                <th class="px-4 py-2 font-semibold">{{ 'ESTIMATED_RECEIVED_TOKEN' | translate }}</th>
                <th class="px-4 py-2 font-semibold">{{ 'NETWORK_FEE' | translate }}</th>
                <th class="px-4 py-2 text-right font-semibold">{{ 'ACTION' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let r of otherRoutes"
                  class="border-t border-gray-100/70 dark:border-white/10
               even:bg-black/0 dark:even:bg-white/5">
                <td class="px-4 py-3">
                  <div class="flex items-center gap-2">
                    <img *ngIf="getRouteLogo(r)" [src]="getRouteLogo(r)!" alt="" class="w-5 h-5 rounded-full" />
                    <span class="font-medium">{{ getRouteProvider(r) }}</span>
                  </div>
                </td>

                <td class="px-4 py-3">
                  <div class="font-medium">{{ getRouteEstimatedBuy(r) }}</div>
                  <div class="text-xs text-slate-500 dark:text-slate-400"
                       *ngIf="getRouteEstimatedBuyFiat(r) as fiat">
                    {{ fiat }}
                  </div>
                </td>

                <!-- Frais réseau (2 lignes : LiFi + MM) -->
                <td class="pl-5 pr-1 pb-2 align-top w-[34%] whitespace-nowrap">
                  <!-- LiFi -->
                  <ng-container *ngIf="getRouteLifiFee(r) as lifi">
                    <div class="text-[11px] text-slate-500 dark:text-slate-400">{{ lifi.textEth }}</div>
                    <div class="text-[11px] text-slate-500 dark:text-slate-400" *ngIf="lifi.textFiat">
                      {{ lifi.textFiat }}
                    </div>
                  </ng-container>

                  <!-- MM (expected / max) -->
                  <!--<ng-container *ngIf="getRouteMmFee(r) as mm">
                    <div class="mt-1 text-[11px] text-slate-600 dark:text-slate-300 font-medium">MM</div>
                    <div class="text-[11px] text-slate-500 dark:text-slate-400">{{ mm.textEth }}</div>
                    <div class="text-[11px] text-slate-500 dark:text-slate-400" *ngIf="mm.textFiat">
                      {{ mm.textFiat }}
                    </div>
                  </ng-container>-->
                </td>


                <td class="px-4 py-3 text-right"
                    [attr.data-selected]="isAltSelected(r)">
                  <button *ngIf="!isAltSelected(r); else altSelected"
                          type="button"
                          (click)="onValidateAlternative(r)"
                          [disabled]="isAlternativeDisabled(r)"
                          class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md border text-xs font-medium
               bg-green-600/90 text-white border-green-600
               hover:opacity-90
               disabled:bg-transparent disabled:text-gray-400 disabled:border-gray-300 disabled:cursor-not-allowed">
                    <svg class="w-3 h-3"
                         [ngClass]="{ 'text-white': !isAlternativeDisabled(r), 'text-gray-400': isAlternativeDisabled(r) }"
                         viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 9.85a1 1 0 011.414-1.414l3.122 3.122 6.364-6.364a1 1 0 011.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                    {{ 'VALIDATE' | translate }}
                  </button>




                  <!-- Si sélectionnée : badge vert -->
                  <ng-template #altSelected>
                    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md
               border border-green-500/60 bg-green-50 text-green-700
               text-xs font-medium">
                      <svg class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-7.071 7.071a1 1 0 01-1.414 0L3.293 9.85a1 1 0 011.414-1.414l3.122 3.122 6.364-6.364a1 1 0 011.414 0z"
                              clip-rule="evenodd" />
                      </svg>
                      {{ 'COMMON.SELECTED' | translate }}
                    </span>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <div class="my-3 text-center">
          <button type="button"
                  (click)="showAlternatives = false"
                  class="inline text-sm font-medium text-blue-600 underline
           p-0 m-0 bg-transparent !border-0 !shadow-none !ring-0
           hover:!shadow-none hover:bg-transparent
           focus:!outline-none focus:!ring-0 active:!shadow-none
           appearance-none rounded-none select-none">
            {{ 'CLOSE_TABLE' | translate }}
          </button>
        </div>
      </div>

    </div>

    <!-- Close -->
    <div class="flex justify-end">
      <button class="text-xs font-bold underline flex items-center gap-1 text-gray-700 dark:text-gray-200"
              (click)="closePreview()">
        <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </div>
</div>




<!-- Effets desktop pour le bouton "Validate" (aligné avec ton style) -->
<style>
  @media (min-width: 768px) {
    .validate-btn {
      transition: all .25s ease-in-out
    }

      .validate-btn:hover {
        cursor: pointer;
        opacity: .9;
        box-shadow: 0 0 8px rgba(34,197,94,.5);
        border: 2px solid #22c55e;
        transform: scale(1.03)
      }
  }
</style>
<!-- Styles fins pour nombres tabulaires & micro-polish -->
<style>
  .num {
    font-variant-numeric: tabular-nums lining-nums;
    letter-spacing: .01em;
  }
</style>
